import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import _ from "lodash";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { EditInvoiceDetailsForm } from "MODULES/Orders/shared/EditInvoiceDetailsForm";
import * as actions from "MODULES/PurchaseOrders/actions";
import { PURCHASE_ORDER } from "../../../constants";

export default function EditInvoiceDetails({ purchaseOrder }) {
  if (purchaseOrder.get("cancelled")) {
    return false;
  }

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="dollar" fixed />
          &nbsp;Edit Billing
          <Modal open={visible} close={close} dialogClass="modal-lg">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Edit Billing Details</h4>
            </Header>
            <EditInvoiceDetailsForm
              close={close}
              displaySerial
              order={purchaseOrder.toJS()}
              orderType={PURCHASE_ORDER}
              initialValues={Object.assign(purchaseOrder.toJS(), {
                invoice_paid_date: null,
                invoice_date: null,
                invoice_number: null,
                line_items: purchaseOrder
                  .toJS()
                  .line_items.filter(l => !l.cancelled)
                  .map(l => ({
                    id: l.id,
                    amount_paid: l.amount_paid,
                    inventory: _.merge(l.inventory, {
                      serial_number: l.serial_number || l.expected_serial_number
                    }),
                    part: l.part,
                    invoice_number: l.invoice_number,
                    invoice_date: l.invoice_date,
                    invoice_paid_date: l.invoice_paid_date,
                    invoice_due_date: l.invoice_due_date
                  }))
              })}
              bulkUpdate={actions.bulkUpdateLineItems}
            />
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

EditInvoiceDetails.propTypes = {
  purchaseOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/EditInvoiceDetails/EditInvoiceDetails.jsx